import { DateTimeFormats } from 'vue-i18n'

export const messages = {
  en: {
    pageTitles: {
      arrangedPayments: 'Arranged Payments',
      scheduledPayments: 'Scheduled Payments',
      billDetail: 'Your Bill',
      bills: 'Bills',
      yourAccounts: 'Your Accounts',
      accountsSubtitle: 'Manage and pay your bills in one place',
      checkEmailPrompt: 'Check Your Email',
      checkMessagesPrompt: 'Check Your Text Messages',
      confirmPin: 'Confirm Your PIN',
      congratulations: 'Congratulations!',
      createPin: 'Create Your PIN',
      enterEmailPrompt: 'Enter Your Email',
      enterPhonePrompt: 'Enter Your Phone Number',
      login: 'Welcome',
      linkExpiredPrompt: 'This link has expired',
      messageSettings: 'Communication Preferences',
      newCustomerRegistration: 'Register Your Account',
      notFound: 'Page Not Found',
      paymentMethods: 'Payment Methods',
      receipts: 'Receipts',
      resetEmail: 'Reset Email',
      resetPin: 'Reset PIN',
      sendNewLinkPrompt: 'Enter Your Details',
      setNewPassword: 'Set New Password',
      setNewPasswordSuccess: 'Successfully Set Password',
      setNewPin: 'Set New PIN',
      setNewPinSuccess: 'Successfully Set PIN',
      setUpPayments: 'Set Up Your Payments',
      thankYou: 'Thank You',
      cashTitle: 'How to pay with cash:',
      cashBannerAlt: 'Cash Retail',
      cashLocations: 'BlytzCash™ Locations'
    },
    drawerTitles: {
      addACH: 'Add Bank Account',
      addCard: 'Add a Card',
      deletePaymentMethod: 'Delete Payment Method',
      editACH: 'Edit Bank Account',
      editCard: 'Edit Card',
      multipayConfirmation: 'Confirm Multi-Card Payment',
      paymentConfirmation: 'Confirm Payment',
      paymentMethod: 'Payment Method',
      paymentMethodAccounts: 'Account(s) using payment method',
      paymentMethodPicker: 'Add a Payment Method',
      schedulePayment: 'Schedule A Payment',
      setupAutopay: 'Set Up Autopay',
      autopayDetails: 'Autopay Details',
      cashTermsTitle: 'Terms'
    },
    labels: {
      accountName: 'Account Name',
      accountType: 'Account Type',
      addPaymentMethod: 'Add a Payment Method',
      expiredCardsWarning:
        'Your card(s) are expired. Please create a new payment method.',
      amountDue: 'Amount Due',
      amountScheduled: 'Amount Scheduled',
      selectedPromisesAmount: 'Selected Promises Amount',
      approved: 'Approved',
      autoPay: 'Autopay',
      autopayDisabled: 'Autopay Disabled',
      autopayEnabled: 'Autopay Enabled',
      paymentMethodCaps: 'PAYMENT METHOD',
      amount: 'Amount',
      chargedOn: 'Charged on',
      cardNoun: 'card',
      bankAccountNoun: 'account',
      billAmount: 'Total',
      billing: 'Billing',
      convenienceFee: 'Convenience Fee',
      waived: 'Waived',
      convenienceFeeWaived: 'Convenience Fee: Waived',
      customerService: 'Customer Service',
      declined: 'Declined',
      defaultPaymentMethod: 'Default Payment Method',
      due: 'Due:',
      dueDate: 'Due Date',
      email: 'Email',
      fee: 'Fee',
      lastFour: 'Last Four',
      logout: 'Logout',
      marketing: 'Marketing',
      multipay: 'Multi Pay',
      nickname: 'Nickname',
      password: 'Password',
      passwordConfirm: 'Confirm Password',
      paymentAmount: 'Payment Amount',
      paymentType: 'Payment Type',
      phone: 'Phone Number',
      poweredBy: 'Powered By',
      TermsAndConditions: 'Terms & Conditions',
      PrivacyPolicy: 'Privacy Policy',
      processedDate: 'Processed Date',
      rejected: 'Rejected',
      routingNumber: 'Routing Number',
      scheduledAmount: 'Scheduled Amount',
      scheduledDate: 'Scheduled Date',
      scheduledPayment: 'Scheduled Payment',
      processesAt: 'Processes at',
      selectLanguage: 'Language',
      sms: 'Text',
      total: 'Total',
      totalAlreadyPaid: 'Already Paid',
      unnamed: 'UNNAMED',
      EMAIL: 'Email',
      TEXT: 'Text',
      billAmountCash: 'Pay this Amount With Cash',
      balance: 'Balance:',
      // Invoice line item with no category from the DMS. Distinct from
      // `balance` above, which is a heading and carries a trailing colon.
      invoiceBalance: 'Balance',
      cvvConfirmationRequired: 'CVV required.',
      AI_CALLS: 'AI Calls',
      AI_TEXTS: 'AI Texts',
      // Shown while the AI Texts checkbox is locked because Text is off.
      aiTextsRequiresText: 'Turn on Text to enable AI Texts.',
      DEALER: 'Auto Loan',
      PROPERTY: 'Rent'
    },
    achLabels: {
      accountNickName: 'Account Nickname',
      accountNumber: 'Account Number',
      accountType: 'Account Type',
      nameOnAccount: 'Name on Account',
      routingNumber: 'Routing Number',
      selectTypePrompt: 'Please Select Account Type',
      typeChecking: 'Checking',
      typeSavings: 'Savings',
      typePersonalChecking: 'Personal Checking',
      typePersonalSavings: 'Personal Savings',
      typeBusinessChecking: 'Business Checking',
      typeBusinessSavings: 'Business Savings',
      useForFuturePayments:
        'Allow merchant to use this payment method for future payments'
    },
    cardLabels: {
      cardNickName: 'Card Nickname',
      cardNumber: 'Card Number',
      cvv: 'CVV',
      expiration: 'Expiration',
      nameOnCard: 'Name on Card',
      streetAddress: 'Street Address',
      city: 'City',
      state: 'State',
      postalCode: 'Postal Code',
      useForFuturePayments:
        'Allow merchant to use this card for future payments'
    },
    placeholders: {
      enterAddress: 'Start typing an address...'
    },
    cashLabels: {
      termsCashSubject: 'Click Here for Terms & Conditions',
      termsFirstParagraph:
        'By accepting or using this barcode to make a payment, you agree to the terms and conditions.',
      termsSecondParagraph:
        'After a successful payment using this barcode, you may retrieve your full detailed e-receipt at',
      info: {
        firstParagraph:
          '1. Find a nearby retail location using the Location Finder.',
        secondParagraph: '2. Generate a barcode for your payment.',
        thirdParagraph: '3. Provide your barcode and cash to the cashier.',
        fourthParagraph:
          '4. Make your payment. Funds will be applied to your account within minutes, and your payment will be complete.'
      },
      barcodeExpiryHelper:
        'Show this barcode to the cashier. If it expires, generate a new one. Barcodes expire after 1 hour.',
      geoDenied:
        'Enable location access in your browser or filter by address to find stores near you.',
      geoUnavailable: 'Location services are unavailable.'
    },
    buttons: {
      accounts: 'Accounts',
      addACH: 'Add Bank Account',
      addCard: 'Add Card',
      splitPayment: 'Split Payment',
      arrangePayments: 'Arrange Payments',
      back: 'Back',
      backToLogin: 'Back To Login',
      cancel: 'Cancel',
      yesEnable: 'Yes, enable',
      cancelScheduled: 'Cancel Scheduled Payment',
      close: 'Close',
      // aria-label on the toast dismiss glyph; see src/plugins/toast.ts.
      dismiss: 'Dismiss',
      delete: 'Delete',
      home: 'Home',
      invoice: 'View Invoice',
      login: 'Login',
      loginHelp: 'Trouble Logging In?',
      manuallySendPaymentLink: 'Please click to send a new payment link',
      makePayment: 'Pay Now!',
      payNow: 'Pay Now',
      next: 'Next',
      nextPayment: 'Next Payment',
      open: 'Open',
      register: 'Register',
      resetPin: 'Reset My PIN',
      save: 'Save',
      schedulePayment: 'Schedule A Payment',
      schedulePaymentUpdate: 'Update Scheduled Payments',
      selectPayment: 'Select Payment Method',
      sendLoginLink: 'Send Login Link',
      sendMeLoginLink: 'Send me a link',
      pinLoginTab: 'PIN',
      emailLoginTab: 'Email & Password',
      setNewPassword: 'Reset My Password',
      sendPaymentLink: 'send a new payment link',
      setNewPin: 'Set New PIN',
      setPayments: 'Set Payments',
      submitPayments: 'Confirm Payments',
      toLogin: 'Go To Login',
      toBills: 'Go To Bills',
      update: 'Update',
      updateAutopay: 'Update Autopay',
      manageAutopay: 'Manage',
      autopayDetails: 'Details',
      generateBarcode: 'Generate Barcode',
      findLocation: 'Location Finder',
      refreshBarcode: 'Refresh Barcode (15 minutes)',
      setUpPin: 'Set up a PIN',
      setUpPassword: 'Set up a password'
    },
    mainNavigation: {
      accounts: 'Accounts',
      bills: 'Bills',
      messageSettings: 'Communication Preferences',
      paymentMethods: 'Payment Methods',
      receipts: 'Receipts',
      scheduledPayments: 'Scheduled Payments'
    },
    scheduledPayments: {
      autopay: 'Autopay',
      scheduled: 'Scheduled',
      promise: 'Promise',
      pending: 'Pending',
      unconfirmed: 'Unconfirmed'
    },
    messages: {
      noAccounts: 'No accounts found.',
      loadError: 'Something went wrong. Please try again.',
      addAMethod: 'Please add a payment method',
      cancelPromise:
        'The above payment(s) will automatically run on the displayed dates. Please contact your merchant to cancel or modify payments.',
      cancelPromiseCash:
        'The above payment(s) will automatically run on the displayed dates. Please contact your merchant to cancel, modify payments, or pay with cash.',
      checkEmailRegistrationPrompt:
        'Please check your email for instructions on how to complete registration.',
      checkEmailResetPasswordPrompt:
        'Please check your email for instructions on how to set a new password.',
      checkPhoneResetPasswordPrompt:
        'Please check your text messages for instructions on how to set a new PIN.',
      checkTextMessagesPromptAccount:
        'If this account matches our records, you will receive a text message with a login link.',
      checkTextMessagesPromptPhone:
        'If the details entered match our records, you will receive a text message with a login link.',
      deletePaymentMethodText:
        'Deleting this payment method will affect everything listed below. Are you sure you want to delete it?',
      deleteAutopayPaymentMethodText:
        'This Payment Method is part of an existing Autopay schedule. Please contact the merchant to change, update, or remove this Payment Method.',
      noPaymentSelected: 'No Payment Selected',
      noReceipt: 'No Receipts Yet',
      noScheduledPayments: 'No Scheduled Payments',
      paymentSuccess:
        'Your payment of <strong>{receiptAmount}</strong> was successful!',
      pinSuccess: `
      <p>
        You have successfully reset your PIN. Please check your text messages for a link to log in with your new PIN.
      </p>
      <p>Or</p>
      <p>
        Set up a password to log in directly.
      </p>
      `,
      promiseVerify:
        'By clicking submit, you agree to be charged the specified amount to each payment method on the scheduled dates.',
      promisesPayInfo:
        'The selected payments will be processed immediately upon clicking the "Pay Now" button.',
      promiseVerifyCash:
        'By clicking submit, you agree to contact the merchant to pay the amount listed in cash.',
      promiseVerifyPartial:
        'By clicking submit, you agree to be charged the specified amount to each payment method on the scheduled dates, and to contact the merchant to pay the cash amount listed.',
      resetPinSuccess: `
        <p>
          You have successfully reset your PIN. Please check your text messages for a bill link to access your PIN login.
        </p>
        <p>Or</p>
        <p>
          Set up a password to log in directly.
        </p>
      `,
      resetPasswordSuccess: 'You have successfully reset your password.',
      registrationSuccess:
        'You have successfully registered. Please use your {method} to log in.',
      requiresPaymentMethod: 'Requires Payment Method',
      sendLinkManually: 'Please click the button below to send a new one.',
      unableToDeletePaymentMethodText:
        'Unable to delete the payment method because you have a promised payment. Please contact your merchant to cancel or modify payments.',
      paymentChargedOnDueDateTitle: 'Payment charged on your due date',
      customAutopayScheduleTitle: 'Custom Autopay schedule',
      autopayDueDateInfo:
        'Payments are automatically charged on the due date provided by {merchantName}.',
      autopayDueDatePending:
        'Your next payment will be scheduled once {merchantName} sends the next invoice.',
      autopayMerchantManaged: 'Please contact {merchant} to disable Autopay.',
      enableMerchantOnlyAutopayTitle: 'Enable Autopay?',
      enableMerchantOnlyAutopay:
        'Once enabled, only {merchant} can turn Autopay off — you’ll need to contact them to disable it. Do you want to continue?',
      autopayNextDatePending: 'Pending next invoice',
      autopayMonthlyInfo:
        'Your {method} will be charged on the {day} of each month.',
      autopaySemimonthlyInfo:
        'Your {method} will be charged on the {day1} and {day2} of each month.',
      autopayWeeklyInfo: 'Your {method} will be charged weekly on {weekday}.',
      autopayBiweeklyInfo: 'Your {method} will be charged every two weeks.',
      autopayEdgeDayNote:
        'When Autopay is scheduled for the 29th, 30th, or 31st and that day doesn’t occur in a month, the payment is processed on the 1st of the following month.',
      // {time} is already in the viewer's own zone, e.g. "5:45 AM CDT".
      scheduledPaymentRunTime:
        'Payments are processed at {time} on the scheduled date. Please make sure funds are available the night before.',
      scheduledPaymentsRunNote:
        'Scheduled payments are processed early in the morning on their scheduled date. Please have funds available the night before.',
      balanceDisclaimerLine1:
        'Your balance may not reflect your full payoff amount. Your payoff amount also includes any interest you accrue through the day you pay off your loan, and may also include other fees you have incurred and have not yet paid.',
      balanceDisclaimerLine2:
        'Payments may not be reflected in the displayed Balance amount until the next business day.',
      invalidPaymentMethod:
        'is not a valid payment method. Please contact the merchant.',
      cardBrandNotAccepted: '{brand} is not accepted.',
      noPinSetup: "You don't have a PIN yet. Set one up to log in with a PIN.",
      noPasswordSetup:
        "You don't have a password yet. Set one up to log in with a password.",
      applePayUnavailable:
        'Apple Pay is unavailable on this device. Please use a different payment method.',
      applePayFailed:
        'Apple Pay could not be completed. Please try again or use a different payment method.'
    },
    legal: {
      autopayScript:
        'When you enroll in Autopay, your bill for {accountName} will be paid automatically for the total amount on each selected date with the following payment method.',
      termsOfService: `
      <p class="legal">
        I agree to receive bill pay reminder alerts from BlytzPay for
        {merchantName}. See
        <a
          href="https://www.blytzpay.com/terms-and-conditions/"
          target="_blank"
        >
          Terms &amp; Privacy</a
        >.
      </p>
      <p class="legal">
        By registering, I authorize BlytzPay to send me bill-pay
        reminders and payment receipts via SMS &amp; email. Message and
        data rates may apply.
      </p>
      `
    },
    errors: {
      account: {
        already_paid: 'This account has already been paid',
        current_invoice_required: 'Account requires a current invoice',
        external_id: {
          clash: 'Account with provided external ID already exists'
        },
        due_date: {
          autopay_cap: 'Due date with Autopay must not exceed the 28th'
        }
      },
      amountBetween: 'Total must be {min}',
      autopay: {
        already_configured: 'Autopay is already set up by another customer'
      },
      card_number: {
        too_long: 'card_number can be at most 16 characters',
        too_short: 'card_number must be at least 15 characters'
      },
      card_type: {
        invalid: 'Invalid card type'
      },
      customer: {
        shared_secret_incorrect:
          'Provided information does not match customer record'
      },
      exactTotal: 'Payment amount must be {total}',
      invalidCVV2: 'Must be 3 or 4 digits',
      invalidCardHolderName: 'Credit card numbers not allowed in card name',
      invalidEmail: 'Must be a valid email',
      invalidPassword:
        'Must be at least 8 characters long and contain each of the following: one lowercase, one uppercase, one numeric, one special character',
      invalidYearDate: 'Invalid MM/YY',
      maxLength: 'Max length of {max} characters',
      minLength: 'Must be at least {min} characters',
      minAmount: 'Must be at least {min}',
      maxAmount: 'Cannot exceed {max}',
      passwordMatch: 'Passwords do not match',
      required: 'Required',
      ssn_invalid_format: 'SSN must be 9 digits. Dashes not allowed',
      location: {
        customer_account_mismatch:
          'Customer does not belong to provided merchant location'
      },
      password: {
        already_set: 'Password has already been set',
        mismatch: 'Passwords do not match'
      },
      payment: {
        already_scheduled: 'Payment is already scheduled for this account',
        beyond_due_date: 'Cannot schedule payment beyond due date',
        minimum: 'Payment must be larger than $1.00'
      },
      payment_amount: {
        does_not_match: 'Combined amounts do not match the amount due',
        too_large:
          'Requested payment amount is greater than the maximum allowed',
        too_small: 'Requested payment amount is less than the minimum allowed'
      },
      payment_method: {
        not_found: 'Invalid payment method specified for autopay'
      },

      pin: {
        mismatch: 'Pins do not match'
      },
      template: {
        schedule_clash: 'A template already exists for the chosen days'
      },
      token: {
        invalid: 'Invalid Token'
      },
      // Rendered in bold as the toast's first line. These keys exist only so the
      // copy lives in one place per locale; naming each toast's event is a
      // separate copy story -- do not add per-event titles here without it.
      titles: {
        generic: 'Error',
        paymentFailed: 'Payment Failed',
        applePay: 'Apple Pay'
      },
      user: {
        email_in_use: 'Email address already in use',
        not_found: 'No user found with matching credentials',
        org_already_set: 'User already belongs to an organization'
      }
    },
    // A retry cap is not a decline: neutral info toasts with no `errors.titles.*` entry. {time} is rendered on the
    // consumer's own device clock, which is why the server sends an instant and not a string.
    retryLimit: {
      // The bold first line on both toasts. It lives here, not in errors.titles.*,
      // because a cap is not an error.
      title: 'Too Many Attempts',
      lastAttempt: 'Excessive attempts recorded, 1 attempt remaining',
      capped: 'Excessive attempts exceeded, please try again after {time}',
      cappedNoTime: 'Excessive attempts exceeded, please try again later'
    },
    registrationFields: {
      address: 'Address',
      address2: 'Address 2',
      city: 'City',
      company_name: 'Company Name',
      country: 'Country',
      date_of_birth: 'Date of Birth',
      email: 'Email',
      external_id: 'Account ID',
      first_name: 'First Name',
      language: 'Language',
      last_name: 'Last Name',
      postal_code: 'Postal Code',
      sms_phone_number: 'Phone Number',
      ssn_last_four: 'Last Four of SSN',
      state_province: 'State / Province'
    },
    statuses: {
      ach_return: 'ACH Return',
      cancelled: 'Cancelled',
      chargeback: 'Chargeback',
      declined: 'Declined',
      delivered: 'Delivered',
      error: 'Error',
      failed: 'Failed',
      finished: 'Finished',
      needs_review: 'Needs Review',
      ok: 'Success',
      paid: 'Paid',
      pending: 'Pending',
      promised: 'Promised',
      promise_confirmed: 'Confirmed Promise',
      refund: 'Refund',
      rejected: 'Rejected',
      running: 'Running',
      skipped: 'Skipped',
      verify_declined: 'Verify Declined',
      verify_ok: 'Verify Success',
      void: 'Void'
    }
  }
}

export const numberFormats = {
  en: {
    currency: {
      currency: 'USD',
      style: 'currency'
    }
  }
}

export const dateTimeFormats: DateTimeFormats = {
  en: {
    short: {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    },
    long: {
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      month: 'long',
      weekday: 'long',
      year: 'numeric'
    },
    // A clock time with the viewer's zone abbreviation, e.g. "5:45 AM CDT".
    time: {
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short'
    },
    // A retry cap can release up to 24 hours out, where a bare clock time is
    // ambiguous. The weekday disambiguates without spending a full date.
    dayTime: {
      weekday: 'short',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short'
    }
  }
}
